import { Stack, Text } from '@mantine/core';

import { FORM_STATUS } from '@data-access';

interface StackedCellProps {
  values: (number | string | null)[];
  status?: FORM_STATUS;
  suffix?: string | string[];
}
export const StackedCell = ({ values, status, suffix }: StackedCellProps) => {
  const color =
    status === FORM_STATUS.REJECTED
      ? 'red'
      : status === FORM_STATUS.FINISHED
        ? 'pf-green'
        : status === FORM_STATUS.UNDEFINED
          ? 'orange'
          : 'dark';

  return (
    <Stack gap={0}>
      {values.map((value, index) => {
        const v = value === null ? '-' : value;
        return (
          <Text c={color} key={index}>
            {typeof v === 'number' ? v.toFixed(2) : v}
            {value !== null && suffix
              ? ` ${Array.isArray(suffix) ? suffix[index] : suffix}`
              : ''}
          </Text>
        );
      })}
    </Stack>
  );
};
